<div class="modal-wrapper modal-large">
    <section class="page-title">
        <h1><strong>Vincular empresa</strong></h1>
        <mat-icon (click)="fechar()" style="cursor: pointer;">
            close
        </mat-icon>
    </section>

    <section class="filtros">
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Buscar por nome</mat-label>
            <input matInput type="text" [(ngModel)]="filterValue" (input)="filtraValores()"
                placeholder="Digite para filtrar" />
            <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
    </section>

    <section>
        <mat-radio-group [(ngModel)]="enderecoSelecionadoId">
            <mat-radio-button *ngFor="let e of enderecosExibidos" [value]="e.idEstabelecimento" class="endereco-card">
                <div class="endereco-card-content">
                    <img src="../../../assets/svg/icons/distance.svg" alt="" />
                    <p>{{ e.labelEndereco }}</p>
                </div>
            </mat-radio-button>
        </mat-radio-group>
    </section>


    <div class="modal-footer">
        <button matButton="filled" [disabled]="!enderecoSelecionadoId" (click)="vincularEndereco()">
            Vincular endereço selecionado
        </button>
    </div>
</div>